export default {
  /**
   * 获取URL特定查询参数的值
   * @param {string} key
   * @returns {string}
   */
  getURLSearchParam(key) {
    return decodeURIComponent(new URLSearchParams(location.search).get(key) || '');
  },

  /**
   * 修改URL特定查询参数的值
   * @param {string} key
   * @param {string} value
   */
  changeURLSearchParam(key, value) {
    const params = new URLSearchParams(location.search);
    if (params.has(key)) {
      params.set(key, value);
    }
    return this.toSearchString(params);
  },

  /**
   * 将查询参数转换为查询字符串
   * @param {URLSearchParams} params
   * @returns {string|string}
   */
  toSearchString(params) {
    return params.size ? `?${params.toString()}` : '';
  },

  /**
   * 获取URL上的appId查询参数
   * @returns {string}
   */
  getAppId() {
    const params = new URLSearchParams(location.search);
    const idaasExtField = params.get('idaas_ext_field');
    if (idaasExtField) {
      const obj = JSON.parse(atob(idaasExtField));
      return obj['x_app_id'] || '';
    }
    return params.get('x_app_id') || '';
  },

  /**
   * 组装路径查询参数
   * @param {URLSearchParams} params
   * @return {URLSearchParams}
   */
  assembleParams(params) {
    if (!params.size) {
      return params;
    }
    const deviceId = params.get('deviceId');
    if (deviceId) {
      const idaasExtField = params.get('idaas_ext_field');
      if (!idaasExtField) {
        const version = params.get('v');
        const appId = params.get('x_app_id');
        const newValue = btoa(JSON.stringify({ v: version, x_app_id: appId, deviceId }));
        params.set('idaas_ext_field', newValue);
      }
      params.delete('deviceId');
      params.delete('x_app_id');
      params.delete('v');
    }
    if (!params.has('redirect')) {
      params.delete('mfaKey');
      params.delete('maskUid');
    }
    const deduplication = Object.entries(Object.fromEntries(params.entries()));
    const filterEmpty = deduplication.filter(([key, value]) => !!value);
    return new URLSearchParams(filterEmpty);
  },

  /**
   * 跳转到其他HTML页面（非当前应用的路由）
   * @param {string} url
   * @param {Object.<string,string|number>} addParams
   * @param {Array<string>} deleteParams
   */
  jumpTo(url, addParams = {}, deleteParams = []) {
    const params = new URLSearchParams(location.search);
    if (params.has('redirect')) {
      addParams.redirect = params.get('redirect');
    }
    Object.entries(addParams).forEach(([key, value]) => params.set(key, value ?? ''));
    deleteParams.forEach(key => params.delete(key));
    location.href = this.assembleURL(url, this.assembleParams(params));
  },

  /**
   * 组装URL
   * @param {string} url
   * @param {Object|URLSearchParams} params
   * @return {string}
   */
  assembleURL(url, params) {
    const origin =
      process.env.NODE_ENV === 'production' ? location.origin : 'https://uniportal-sit.huawei.com';
    let searchParams = new URLSearchParams();
    if (params instanceof URLSearchParams) {
      searchParams = params;
    } else {
      const map = Object.entries(params).map(([key, value]) => {
        if (value === undefined) {
          return [key, ''];
        } else {
          return [key, value.toString()];
        }
      });
      searchParams = new URLSearchParams(map);
    }
    return origin + url + this.toSearchString(searchParams);
  },
};
